import { Component, OnInit, inject, Input } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CommonModule, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { UtilizadoresService } from '@app/shared/components/api/services/utilizadores.service';
import { UserService } from '@app/auth/services/user.service';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { DatePicker } from 'primeng/datepicker';
import { MessageModule } from 'primeng/message';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { Select } from 'primeng/select';
import { InputMask } from 'primeng/inputmask';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/services/auth.service';
import { ApoioService } from '@app/shared/components/api/services/apoio.service';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';

export function idadeValidator(
  minIdade: number = 15,
  maxIdade: number = 90,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    let dataNasc: Date;
    if (control.value instanceof Date) {
      dataNasc = control.value;
    } else if (typeof control.value === 'string' && control.value.includes('/')) {
      const parts = control.value.split('/');
      if (parts.length === 3) {
        dataNasc = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      } else {
        dataNasc = new Date(control.value);
      }
    } else {
      dataNasc = new Date(control.value);
    }

    if (isNaN(dataNasc.getTime())) {
      return { dataInvalida: true };
    }
    const hoje = new Date();
    let idade = hoje.getFullYear() - dataNasc.getFullYear();
    const m = hoje.getMonth() - dataNasc.getMonth();
    if (m < 0 || (m === 0 && hoje.getDate() < dataNasc.getDate())) {
      idade--;
    }
    if (idade < minIdade || idade > maxIdade) {
      return { idadeInvalida: { idade, min: minIdade, max: maxIdade } };
    }
    return null;
  };
}

@Component({
  selector: 'app-perfil',
  imports: [
    BreadcrumbModule,
    CommonModule,
    ButtonModule,
    DatePipe,
    DialogModule,
    Select,
    ConfirmDialogModule,
    ReactiveFormsModule,
    InputText,
    DatePicker,
    MessageModule,
    MoneyPipe,
    InputMask,
  ],
  providers: [
    UtilizadoresService,
    UserService,
    ConfirmationService,
    EnumService,
    AuthService,
    ApoioService,
  ],
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.scss',
})
export class PerfilComponent implements OnInit {
  @Input() hideBreadcrumb = false;
  items: MenuItem[] = [];
  private readonly utilizadoresService = inject(UtilizadoresService);
  private readonly userService = inject(UserService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly messageService = inject(MessageService);
  private readonly enumService = inject(EnumService);
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly apoioService = inject(ApoioService);
  home: MenuItem | undefined;
  utilizador: any;
  formPerfil!: FormGroup;
  showDialog = false;
  formSubmitted = false;
  tipoDocs: any[] = [];
  numberValid: any;
  loading: boolean = false;
  loadingNif: boolean = false;
  ShowBTN: boolean = false;
  IsAuthenticad: boolean = true;
  IsprofileComplet: boolean = false;
  nifValidado = true;
  isAnonimoChecked: boolean = false;
  hoje: Date = new Date();
  minDate: Date = new Date(
    new Date().getFullYear() - 90,
    new Date().getMonth(),
    new Date().getDate(),
  );
  maxDate: Date = new Date(
    new Date().getFullYear() - 15,
    new Date().getMonth(),
    new Date().getDate(),
  );
  defaultDate: Date = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth(),
    new Date().getDate(),
  );
  private aplicarRegrasTimeout: any;
  saldoUser: any;

  typeUserOptions = [
    { value: true, label: 'Sim' },
    { value: false, label: 'Não' },
  ];

  nacional = [
    { label: 'Angolana', value: true },
    { label: 'Estrangeira', value: false },
  ];

  ngOnInit(): void {
    this.authService.isAuthenticatedChange().subscribe((isAuth) => {
      this.IsAuthenticad = isAuth;
    });
    this.items = [{ label: 'Perfil' }];
    this.home = { icon: 'pi pi-home', routerLink: '/' };
    this.getUser();
    // this.getSaldoByUser();
    this.getTipoDocumentos();
    this.initForm();
    this.checkProfileUSer();
    this.aplicarRegrasFormulario();
    if (!this.IsAuthenticad) {
      this.router.navigate(['/']);
    }
  }

  getUserInitials(): string {
    const name =
      this.utilizador?.nomeCompleto || this.utilizador?.userName || 'U';
    return name.slice(0, 2).toUpperCase();
  }

  // getSaldoByUser() {
  //   this.apoioService.consultarSaldoUser(this.userService.getUserId() ?? '').subscribe({
  //     next: (res) => {
  //       if (res?.retorno?.codigo === 200) {
  //         this.saldoUser = res?.retorno?.mensagem;
  //       }
  //     },
  //   })
  // }

  getTipoDocumentos(): void {
    this.enumService.getAllTipoDocumento().subscribe({
      next: (res) => {
        this.tipoDocs = Object.entries(res.data).map(([key, value]) => ({
          id: Number(key),
          label: value as string,
        }));
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  getUser(): void {
    this.loading = true;
    const userId = this.userService.getUserId();
    if (userId) {
      this.utilizadoresService.show(userId).subscribe({
        next: (res) => {
          this.utilizador = res.data;
          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        },
      });
    } else {
      console.error('User ID is null');
      this.loading = false;
      return;
    }
  }

  initForm() {
    this.formPerfil = this.fb.group({
      userName: [{ value: null, disabled: true }, Validators.required],
      email: [
        { value: null, disabled: true },
        [Validators.required, Validators.email],
      ],
      telefone: [
        { value: null, disabled: true },
        [Validators.required, Validators.pattern(/^9\d{8}$/)],
      ],
      nacionalidade: [{ value: null, disabled: false }, Validators.required],
      dataNascimento: [
        { value: null, disabled: true },
        [Validators.required, idadeValidator(15, 90)],
      ],
      nif: [
        { value: null, disabled: true },
        // [Validators.required, Validators.minLength(14), Validators.maxLength(14)]
      ],
      iban: [
        { value: null, disabled: true },
        [
          // Validators.pattern(/^AO06\s\d{4}-0000-\d{13}$/)
        ],
      ],
      tipoDocumentoENUM: [{ value: null, disabled: true }, Validators.required],
      anonimo: [{ value: null, disabled: false }, Validators.required],
      nomeUtilizador: [{ value: null, disabled: false }, Validators.required],
    });

    this.formPerfil.get('nif')?.valueChanges.subscribe(() => {
      const currentNif = this.formPerfil.get('nif')?.value;
      if (
        this.utilizador?.numeroDocumento &&
        currentNif === this.utilizador.numeroDocumento
      ) {
        this.nifValidado = true;
      } else {
        this.nifValidado = false;
      }
      this.aplicarRegrasFormulario();
    });

    this.formPerfil.get('anonimo')?.valueChanges.subscribe(() => {
      this.aplicarRegrasFormulario();
    });

    this.formPerfil.get('nacionalidade')?.valueChanges.subscribe(() => {
      const currentNif = this.formPerfil.get('nif')?.value;
      if (
        this.utilizador?.numeroDocumento &&
        currentNif === this.utilizador.numeroDocumento
      ) {
        this.nifValidado = true;
      } else {
        this.nifValidado = false;
      }
      if (this.aplicarRegrasTimeout) {
        clearTimeout(this.aplicarRegrasTimeout);
      }
      this.aplicarRegrasTimeout = setTimeout(() => {
        this.aplicarRegrasFormulario();
      }, 50);
    });
  }

  showEditDialog() {
    if (!this.utilizador) return;

    const isNacional =
      this.utilizador.tipoDocumentoENUM === 1
        ? true
        : this.utilizador.tipoDocumentoENUM === 2
          ? false
          : null;

    this.nifValidado = !!(
      this.utilizador.numeroDocumento || this.IsprofileComplet
    );

    const docTipo =
      this.utilizador.tipoDocumentoENUM ||
      (isNacional === false ? 2 : (this.tipoDocs?.[0]?.id ?? 1));

    this.formPerfil.patchValue(
      {
        userName: this.utilizador.userName,
        email: this.utilizador.email,
        telefone: this.utilizador.telefone,
        dataNascimento: this.utilizador.dataNascimento
          ? new Date(this.utilizador.dataNascimento)
          : null,
        iban: this.utilizador.iban,
        nif: this.utilizador.numeroDocumento,
        tipoDocumentoENUM: docTipo,
        anonimo: this.utilizador.anonimo ?? false,
        nomeUtilizador: this.utilizador.nomeUtilizador,
        nacionalidade: isNacional,
      },
      { emitEvent: false },
    );

    this.isAnonimoChecked = this.utilizador.anonimo === true;
    this.loadingNif = false;
    this.showDialog = true;

    // Aplicar regras após popular o formulário para garantir estados corretos
    this.aplicarRegrasFormulario();
  }

  OnSerachNIF() {
    if (this.loadingNif) return;

    const nif = (this.formPerfil.get('nif')?.value || '').toString().trim();
    if (!nif || this.formPerfil.get('nif')?.invalid) {
      this.messageService.add({
        severity: 'info',
        summary: 'NIF incorretamente preenchido',
        detail: 'Verifique o seu NIF e tente novamente',
        life: 5000,
      });
      return;
    }

    this.loadingNif = true;

    const userID = this.userService.getUserId() || '';
    this.utilizadoresService.getInforByNIF(nif, userID).subscribe({
      next: (res) => {
        this.loadingNif = false;
        if (res?.retorno?.codigo === 200) {
          this.nifValidado = true;
          this.formPerfil.patchValue(
            {
              userName: res.data?.ObterContribuinte?.contribuinte?.nome,
              nif: res.data?.ObterContribuinte?.contribuinte?.numeroNIF,
            },
            { emitEvent: false },
          );
          this.aplicarRegrasFormulario();
          this.messageService.add({
            severity: 'success',
            summary: 'NIF Validado',
            detail: 'NIF validado com sucesso!',
            life: 4000,
          });
        } else {
          this.nifValidado = false;
          this.formPerfil.get('nif')?.reset();
          this.aplicarRegrasFormulario();
          this.messageService.add({
            severity: 'info',
            summary: 'Informação',
            detail:
              `${res?.retorno?.mensagem}` || 'Falha ao verificar o seu NIF',
            life: 5000,
          });
        }
      },
      error: () => {
        this.loadingNif = false;
        this.ShowBTN = true;
        this.nifValidado = false;
        this.aplicarRegrasFormulario();
        this.messageService.add({
          severity: 'info',
          summary: 'Falha',
          detail: 'Falha ao verificar o seu NIF',
          life: 5000,
        });
      },
    });
  }

  UpdatePerfil() {
    if (this.formPerfil.invalid) {
      this.formSubmitted = false;
      this.formPerfil.markAllAsTouched();
      return;
    } else {
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja atualizar o perfil?',
        header: 'Confirmação',
        closable: true,
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectButtonProps: {
          label: 'Não',
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: 'Sim',
        },
        accept: () => {
          const data = this.formPerfil.get('dataNascimento')?.value;
          const updatedData = {
            userID: this.userService.getUserId(),
            nome: this.formPerfil.get('userName')?.value,
            telefone:
              this.formPerfil.get('telefone')?.value || this.numberValid,
            dataNascimento: data
              ? new Date(data.getTime() - data.getTimezoneOffset() * 80000)
                  .toISOString()
                  .split('T')[0]
              : null,
            numeroDocumento: this.formPerfil.get('nif')?.value,
            iban: this.formPerfil.get('iban')?.value,
            tipoDocumentoENUM: this.formPerfil.get('tipoDocumentoENUM')?.value,
            anonimo: this.formPerfil.get('anonimo')?.value,
            nomeUtilizador: this.formPerfil.get('nomeUtilizador')?.value,
          };

          this.utilizadoresService.update(updatedData).subscribe({
            next: (res) => {
              if (res?.retorno?.codigo === 200) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Sucesso',
                  detail: 'Perfil atualizado com sucesso',
                  life: 5000,
                });
                this.closeEditDialog();
                this.getUser();
                this.checkProfileUSer();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Erro',
                  detail:
                    res?.retorno?.mensagem ||
                    'Ocorreu um erro ao atualizar o perfil',
                  life: 5000,
                });
                return;
              }
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Ocorreu um erro ao atualizar o perfil',
                life: 5000,
              });
              console.error(err);
            },
          });
        },
        reject: () => {
          // Ação ao cancelar (se necessário)
        },
      });
    }
  }

  isInvalid(controlName: string): boolean {
    const control = this.formPerfil.get(controlName);
    return !!(
      control &&
      control.invalid &&
      (control.touched || control.dirty || this.formSubmitted)
    );
  }

  closeEditDialog() {
    this.formPerfil.reset();
    this.showDialog = false;
    this.nifValidado = false;
    this.isAnonimoChecked = false;
    this.ShowBTN = false;
    this.loadingNif = false;
  }

  checkProfileUSer() {
    const userId = this.userService.getUserId() || '';
    if (!userId) return;

    this.utilizadoresService.checkPerfilUser(userId).subscribe({
      next: (res: any) => {
        if (res?.retorno?.codigo === 200) {
          this.IsprofileComplet = !!res?.data;
        } else {
          this.IsprofileComplet = false;
        }
        this.aplicarRegrasFormulario();
      },
      error: (err) => {
        console.error('Erro ao verificar perfil:', err);
        this.aplicarRegrasFormulario();
      },
    });
  }

  private aplicarRegrasFormulario(): void {
    if (!this.formPerfil) return;

    const nacionalidade = this.formPerfil.get('nacionalidade')?.value;
    const perfilCompleto = this.IsprofileComplet;
    const anonimo = this.formPerfil.get('anonimo')?.value;
    const nifCtrl = this.formPerfil.get('nif');
    const nifValidado = this.nifValidado;

    // Helpers
    const disableAll = () => {
      Object.keys(this.formPerfil.controls).forEach((c) => {
        if (this.formPerfil.get(c)?.enabled) {
          this.formPerfil.get(c)?.disable({ emitEvent: false });
        }
      });
    };

    const enable = (fields: string[]) => {
      fields.forEach((f) => {
        if (this.formPerfil.get(f)?.disabled) {
          this.formPerfil.get(f)?.enable({ emitEvent: false });
        }
      });
    };

    const disable = (fields: string[]) => {
      fields.forEach((f) => {
        if (this.formPerfil.get(f)?.enabled) {
          this.formPerfil.get(f)?.disable({ emitEvent: false });
        }
      });
    };

    /* ================= RESET BASE ================= */
    disableAll();

    /* ================= CAMPOS SEMPRE POSSÍVEIS ================= */
    enable(['anonimo']);
    this.isAnonimoChecked = anonimo === true;
    if (anonimo === true) {
      enable(['nomeUtilizador']);
      this.formPerfil
        .get('nomeUtilizador')
        ?.setValidators([Validators.required]);
    } else {
      disable(['nomeUtilizador']);
      this.formPerfil.get('nomeUtilizador')?.clearValidators();
    }
    this.formPerfil
      .get('nomeUtilizador')
      ?.updateValueAndValidity({ emitEvent: false });

    /* ================= PERFIL INCOMPLETO ================= */
    if (!perfilCompleto) {
      enable(['nacionalidade']);

      if (nacionalidade === true) {
        this.ShowBTN = true;
        // Angolano
        this.formPerfil
          .get('tipoDocumentoENUM')
          ?.setValue(1, { emitEvent: false });
        disable(['tipoDocumentoENUM']);

        enable(['nif']);

        if (nifValidado) {
          enable(['telefone', 'dataNascimento', 'iban', 'userName']);
        } else {
          disable(['telefone', 'dataNascimento', 'iban', 'userName']);
        }
      } else if (nacionalidade === false) {
        this.ShowBTN = false;
        // Estrangeiro
        this.formPerfil
          .get('tipoDocumentoENUM')
          ?.setValue(2, { emitEvent: false });
        disable(['tipoDocumentoENUM']);
        nifCtrl?.reset(null, { emitEvent: false });
        disable(['nif']);
        enable(['userName', 'telefone', 'dataNascimento', 'iban']);
      } else {
        this.ShowBTN = false;
        disable([
          'tipoDocumentoENUM',
          'nif',
          'userName',
          'telefone',
          'dataNascimento',
          'iban',
        ]);
      }

      return;
    }

    /* ================= PERFIL COMPLETO ================= */
    // Nacionalidade não pode mais ser alterada
    disable(['nacionalidade']);

    if (nacionalidade === true) {
      this.ShowBTN = false;
      // Angolano
      this.formPerfil
        .get('tipoDocumentoENUM')
        ?.setValue(1, { emitEvent: false });
      disable([
        'tipoDocumentoENUM',
        'nacionalidade',
        'nif',
        'userName',
        'dataNascimento',
        'email',
      ]);
      enable(['telefone', 'iban']);
    } else if (nacionalidade === false) {
      this.ShowBTN = false;
      // Estrangeiro
      this.formPerfil
        .get('tipoDocumentoENUM')
        ?.setValue(2, { emitEvent: false });
      disable([
        'tipoDocumentoENUM',
        'nacionalidade',
        'nif',
        'dataNascimento',
        'email',
      ]);
      nifCtrl?.reset(null, { emitEvent: false });

      enable(['userName', 'telefone', 'iban']);
    }
  }
}
